import React from "react";
import "./CSS/Gallary.css";
import img1 from "./IMAGES/ganpati2.jpg";
import img2 from "./IMAGES/ganpati1.jpg";
import img3 from "./IMAGES/image 3.png"
import img4 from "./IMAGES/ganpati3.jpg";
import img5 from "./IMAGES/ganpati4.jpg"
import img6 from "./IMAGES/image 2.png"


const images = [
  { src: img1, className: "highlight" },
  { src: img2, className: "shadow" },
  { src: img3, className: "bordered" },
  { src: img4, className: "rounded" },
  { src: img5, className: "grayscale" },
  { src: img6, className: "zoom" },
];
const GaneshGallery = () => {
  return (
    <div className="gallery-container">
      <h2 className="gallery-title">छायाचित्र संग्रह</h2>

<div className="gallery-grid">
  {images.map((img, index) => (
    <div key={index} className={`gallery-item ${img.className}`}>
      <img src={img.src} alt={`Ganpati ${index + 1}`} className={img.className} />
    </div>
  ))}
</div>


      {/* <button className="gallery-btn">View Full Gallery</button> */}
    </div>
  );
};

export default GaneshGallery;
